import RegisterBtnComponent from '@components/Default/Register/RegisterBtnComponent';
import SearchComponent from '@components/Default/Search/SearchComponent';
import Page from '@components/Page';
import SelectableDataComponent from '@components/SelectableDataComponent';
import { IProcess } from '@interfaces/ehss/Process';
import IPagination from '@interfaces/IPagination';
import { ITarget } from '@interfaces/ITargets';
import TargetService from '@services/TargetService';
import UserService from '@services/UserService';
import NotificationComponent from '@src/helpers/_showNotifications';
import ProcessRequestsInterceptor from '@src/helpers/interceptors/ProcessRequestInterceptor';
import I18n from '@src/i18n';
import styled from '@src/styled-components';
import { Button, Col, Form, Input, Modal } from 'antd';
import AWS, { S3 } from 'aws-sdk';
import findIndex from 'lodash/findIndex';
import * as React from 'react';

import Table from '../components/TableComponent';
import { LocalStorageKeys } from './App';

export interface ITargetsContainerProps {
  form: any;
}

export interface ITargetsContainerState {
  isLoading: boolean;
  search: string;
  tableData: ITarget[],
  filteredTableData: ITarget[],
  offset?: string,
  loadingMoreFormflows?: boolean,
  loadingRequest?: boolean,
  serverResponse: any;
  openTargetsRegister: boolean;
  openTargetsEdit: boolean;
  editItem?: ITarget;

  showAuditsModal: boolean;
  processesData: IProcess[];
  loadingAudits: boolean;
  curProcessesOffset?: string,
  loadingMoreProcesses: boolean,
  auditsAlreadySaved: IProcess[];
  selectedTarget: string,
  downloadLink: string,
}

const tableColumns = [{
  title: 'table.formflow.name',
  dataIndex: 'name',
  key: 'name',
  class: 'name',
  width: '30%'
}, {
  title: 'targets.qrcode',
  dataIndex: 'url',
  key: 'url',
}, {
  title: 'targets.code',
  dataIndex: 'id',
  key: 'id',
},
{
  title: 'labels.processTitle',
  dataIndex: 'audits',
  key: 'audits',
}, {
  title: 'table.actions',
  dataIndex: 'action',
  key: 'action',
  width: '20%'
}];

export default class TargetsClass extends React.Component<ITargetsContainerProps, ITargetsContainerState> {

  private idUnit: string;
  private _TargetService: TargetService;
  private _processService: ProcessRequestsInterceptor;
  private _userService: UserService;

  constructor(props: ITargetsContainerProps) {
    super(props);
    this.idUnit = String(localStorage.getItem(LocalStorageKeys.ACTIVE_UNIT_ID))
    this._processService = new ProcessRequestsInterceptor();
    this._TargetService = new TargetService();
    this._userService = new UserService();
    this.state = {
      isLoading: true,
      loadingRequest: false,
      search: '',
      tableData: [],
      filteredTableData: [],
      serverResponse: undefined,
      openTargetsRegister: false,
      openTargetsEdit: false,

      showAuditsModal: false,
      processesData: [],
      loadingAudits: false,
      curProcessesOffset: undefined,
      loadingMoreProcesses: false,
      auditsAlreadySaved: [],
      selectedTarget: '',
      downloadLink: ''
    }

    this.onSeeMoreProcesses = this.onSeeMoreProcesses.bind(this);
  }

  componentDidMount() {
    this.getTargets(true)
    this.setState({ isLoading: true });
  }

  getProcesses = async (reset: boolean, showLoading: boolean) => {
    const {
      curProcessesOffset,
    } = this.state;

    this.setState({
      loadingAudits: reset,
      loadingMoreProcesses: !reset,
    });
    if (reset) {
      this.setState({
        curProcessesOffset: undefined
      });
    }
    try {
      if (this.idUnit) {
        const data: any = await this._processService.paging({
          unit: this.idUnit,
          to: undefined,
          from: undefined,
          limit: 15,
          offset: curProcessesOffset,
        });

        const dataTableCreate: any[] = [];
        data.items.map(async (item: any) => {
          dataTableCreate.push({
            key: item.id,
            name: item.name,
            code: item.code,
            id: item.id,
            loading: false,
          })
        });

        let nextProcessesData: any[] = [];

        if (!reset) {
          nextProcessesData = this.state.processesData || [];
        }
        nextProcessesData = nextProcessesData.concat(dataTableCreate);
        this.setState({
          loadingAudits: false,
          processesData: nextProcessesData,
          curProcessesOffset: data.offset || undefined,
        });
      }

      else throw new Error("No unit set");

    } catch (error) {
      this.setState({
        isLoading: false,
        loadingAudits: false,
        loadingMoreProcesses: false,
      });
    }
    this.setState({ loadingMoreProcesses: false });
  }

  async getTargets(reset: boolean, showLoading?: boolean) {
    const { tableData } = this.state;
    if (showLoading != undefined) { this.setState({ isLoading: showLoading }) };

    if (reset) {
      this.setState({
        offset: undefined
      });
    }
    try {
      const data: IPagination<ITarget> = await this._TargetService.paging({
        unit: this.idUnit,
        to: undefined,
        from: undefined,
        search: this.state.search,
        limit: 10,
        offset: this.state.offset
      });
      let newDataTableCreate: ITarget[] = [];
      if (data != undefined) {
        if (!reset) {
          newDataTableCreate = tableData || [];
        }
        newDataTableCreate = newDataTableCreate.concat(data.items);
      }
      this.setState({ tableData: newDataTableCreate, isLoading: false, offset: data.offset, loadingMoreFormflows: false });
    } catch (e) {
      NotificationComponent.Notify('error', I18n.l('common.error'), e);
      this.setState({ isLoading: false, loadingMoreFormflows: false });
    }
  }

  toggleFormModal = async () => {
    this.setState({
      openTargetsRegister: !this.state.openTargetsRegister,
      // serverResponse: undefined,
      editItem: {
        id: '',
        name: '',
        url: ''
      },
    });
    this.props.form.setFieldsValue(
      {
        name: '',
      });
  }

  toggleFormModalEdit = async () => {
    this.setState({
      openTargetsEdit: !this.state.openTargetsEdit,
    });
  }

  async onSubmit() {
    this.setState({ loadingRequest: true })
    try {
      this.setState({ loadingRequest: false })
    } catch (e) {
      NotificationComponent.Notify('error', I18n.l('common.error'), e);
      this.setState({ loadingRequest: false })
    }
  }

  deleteTarget = async (id: string) => {
    try {
      const { tableData } = this.state;
      await this._TargetService.deleteById(id, this.idUnit);

      const nextTableData = tableData.filter((item: ITarget) => item.id !== id);
      this.setState({
        isLoading: false,
        tableData: nextTableData,
      });
      await NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("targets.deleteTarget"));
    } catch (e) {
      NotificationComponent.Notify('error', I18n.l("form.filter.errors.register"), e);
    }
  }

  loadMoreTargets() {
    this.setState({ loadingMoreFormflows: true });
    this.getTargets(false, false);
  }

  onEditTarget = async (editItem: ITarget) => {
    this.setState({
      openTargetsEdit: true,
      editItem: {
        id: editItem.id,
        name: editItem.name,
        url: editItem.url
      }
    })

    this.props.form.setFieldsValue(
      {
        name: editItem.name,
      });
  }

  searchTarget = async (event: any) => {
    event.preventDefault();
    await this.setState({
      search: event.target.find.value,
      isLoading: true
    })
    if (event === '') {
      await this.setState({
        search: ''
      })
    }
    await this.setState({
      isLoading: true,
    })
    this.getTargets(true, true);
  }

  //#endregion


  handleSubmit = async (e: any) => {
    e.preventDefault();
    this.props.form.validateFields((err: any, values: any) => {
      if (!err) {
        this.onSubmitTarget();
      } else {
        console.log('Form submit Errors', err)
      }
    });
  }

  onSubmitTarget = async () => {
    const { tableData, editItem } = this.state;

    const form = this.props.form;

    this.setState({ loadingRequest: true });

    try {
      let nextTableData: ITarget[] = [];
      let values = await form.getFieldsValue();

      if (editItem && editItem.id) {
        let dataEdit: any;

        dataEdit = {
          id: editItem.id,
          name: values.name,
          url: editItem.url
        }

        const response = await this._TargetService.updateById(editItem.id, this.idUnit, dataEdit);
        const targetIndex = findIndex(
          tableData,
          (item: any) => item.id === response.id,
        );
        nextTableData = tableData;
        if (nextTableData[targetIndex]) {
          nextTableData[targetIndex] = Object.assign(nextTableData[targetIndex], response);
        }
        await NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("targets.editTarget"));
      } else {
        values = {
          id: '',
          ...values,
        }
        const response = await this._TargetService.create(values, this.idUnit);

        nextTableData = [response, ...tableData];
        await NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("targets.registerTarget"));
      }
      const dataTableCreate: any = [];
      nextTableData.map((item: any) => {
        dataTableCreate.push({
          id: item.id,
          name: item.name,
          url: item.url,
          created: item.createdAt,
          action: true
        })
      })
      this.setState({ loadingRequest: false, isLoading: false, openTargetsEdit: false, openTargetsRegister: false, tableData: nextTableData });
      await this.getTargets(true)
    } catch (error) {
      NotificationComponent.Notify('error', I18n.l("form.filter.errors.register"), error);
      this.setState({ loadingRequest: false });
    } finally {
    }
  }
  //#endregion

  //#region  Link Process
  toggleProcessModal = async (targetId?: string) => {
    this.setState({ selectedTarget: targetId || '' })

    if (targetId) await this.getTargetsAuditsIds(targetId);

    this.setState({
      showAuditsModal: !this.state.showAuditsModal,
      curProcessesOffset: undefined
    });
    if (this.state.showAuditsModal) {
      this.getProcesses(true, true);
    }

  }

  getTargetsAuditsIds = async (targetId: string) => {
    this.setState({ auditsAlreadySaved: [] });
    const { tableData } = this.state;

    if (tableData != undefined) {
      // debugger
      const person = tableData.filter((item: any) => item.id == targetId);

      let newAuditsSavedData: any = [];
      if (person[0] != undefined) {

        this.setState({ selectedTarget: person[0].id || '' });

        if (person[0].processes != undefined) {
          newAuditsSavedData = person[0].processes;
        }
      }
      this.setState({ auditsAlreadySaved: newAuditsSavedData })
    }
  }

  setLoadingAuditData = async (auditId: string, loading: boolean) => {
    const { processesData: auditsData } = this.state;

    const audit: any = auditsData.find((item) => {
      return item.id == auditId;
    });
    const indexOf = auditsData.indexOf(audit);

    const newAuditsData: any[] = [...auditsData];
    newAuditsData[indexOf].loading = loading;

    this.setState({ processesData: newAuditsData });
  }

  onRemoveAudit = async (id: string) => {
    const { selectedTarget: selectedTarget } = this.state;
    await this.setLoadingAuditData(id, true);

    try {
      await this._TargetService.processRemove(this.idUnit, selectedTarget, id);
      this.auditRemoved(id);
      this.setLoadingAuditData(id, false);
    } catch (error) {
      this.setLoadingAuditData(id, false);
      NotificationComponent.NotifyWithMoreDuration('error', I18n.l('common.error'), error);
    }
  }

  onAddProcess = async (id: string) => {
    const { selectedTarget: selectedTarget } = this.state;
    this.setLoadingAuditData(id, true);


    try {
      await this._TargetService.processAdd(this.idUnit, selectedTarget, id);
      this.processAdded(selectedTarget, id);
      this.setLoadingAuditData(id, false);
    } catch (e) {
      this.setLoadingAuditData(id, false);
    }
  }

  processAdded = async (target: string, id: string) => {
    const { auditsAlreadySaved, tableData } = this.state;

    const newAlreadySaved: any[] = [...auditsAlreadySaved];
    newAlreadySaved.push(id);

    const newTableData = [...tableData];
    let targetIndex = newTableData.findIndex(e => e.id === target);
    if (targetIndex != -1) {
      const newProcesses = newTableData[targetIndex].processes ? newTableData[targetIndex].processes : []
    }
    this.setState({ auditsAlreadySaved: newAlreadySaved, tableData: newTableData });
    this.setProcessesToUser();
  }

  auditRemoved = async (id: string) => {
    const { auditsAlreadySaved } = this.state;

    const newAlreadySaved: any[] = [...auditsAlreadySaved];
    const index = newAlreadySaved.indexOf(id);
    newAlreadySaved.splice(index, 1);
    this.setState({ auditsAlreadySaved: newAlreadySaved });
    this.setProcessesToUser();
  }

  setProcessesToUser() {
    const { tableData, selectedTarget: selectedTarget, auditsAlreadySaved } = this.state;

    if (tableData != undefined) {
      const person = tableData.filter((item: any) => item.id == selectedTarget);
      const index = tableData.indexOf(person[0]);

      let newTableData: any = [...tableData];
      if (newTableData[index] != undefined) {
        if (newTableData[index].processes) {
          newTableData[index].processes = auditsAlreadySaved;
        }
      }
      this.setState({ tableData: newTableData });
    }
  }

  onSeeMoreProcesses() {
    this.getProcesses(false, false);
  }

  formatTargetDataToTable = (target: ITarget[]) => {
    const nextData: any[] = [];
    target.map((target: ITarget) => {



      let processInfo =
        <Col >
          <a href="#" onClick={() => this.toggleProcessModal(target.id || '')}>{I18n.l('table.audits.linkProcess')}</a>
        </Col>;

      // if has process, overrides the processInfo object
      if (target != undefined) {
        if (target != undefined) {
          if (target.processes != undefined) {
            if (target.processes.length > 0) {
              processInfo =
                <Col sm={24} md={12} lg={12}>
                  <a href="#" onClick={() => this.toggleProcessModal(target.id || '')}>{I18n.l('table.audits.seeProcesses')}</a>
                </Col>
            }
          }
        }
      }

      nextData.push({
        id: target.id,
        name: target.name,
        url: target.url,
        audits: processInfo,
      })
    });


    return nextData;
  }

  onDownload = async (item: any) => {
    try {
      const imageUrl = await this.getBase64Image(item.url);
      let tag = document.createElement('a');
      tag.href = imageUrl;
      tag.download = `${item.name}.png`;
      document.body.appendChild(tag);
      tag.click();
      document.body.removeChild(tag);
    }
    catch{
      window.open(item.url, '_blank')
    }
    return false;
  };
  async readS3File(url: string) {
    const storage = JSON.parse(localStorage.getItem('clientUpload') || '');
    const userAccessKey = await this._userService.getAccessAWS('s3');

    AWS.config.update({
      accessKeyId: userAccessKey.AccessKeyId,
      secretAccessKey: userAccessKey.SecretAccessKey,
      sessionToken: userAccessKey.SessionToken,
      region: storage.region
    });

    const s3 = new S3({ apiVersion: '2006-03-01' })
    const i = url.indexOf('.goepik.io/');
    const parms = {
      Bucket: storage.bucket,
      Key: url.substr(i + 11)
    };
    const data = await s3.getObject(parms).promise();
    return data.Body
  }
  async getBase64Image(url: string): Promise<string> {
    const imgData: any = await this.readS3File(url);
    return new Promise((resolve, reject) => {
      try {
        const reader: FileReader = new FileReader();
        reader.onloadend = () => {
          const res: string = reader && reader.result ? reader.result.toString() : '';
          return resolve(res);
        };
        const b = new Blob([imgData]);
        reader.readAsDataURL(b);
      }
      catch (err) {
        console.error(err);
        return reject(err);
      }
    });
  }

  //#endregion


  render() {
    const { getFieldDecorator } = this.props.form;
    const values = this.props.form.getFieldsValue();

    const {
      isLoading,
      search,
      tableData,
      filteredTableData,
      offset,
      loadingMoreFormflows,
      openTargetsRegister,
      openTargetsEdit,

      processesData: auditsData,
      showAuditsModal,
      curProcessesOffset,
      loadingMoreProcesses,
      loadingAudits,
      auditsAlreadySaved,
      serverResponse,
    } = this.state;

    if (isLoading) {
      return (
        <Page>
          <span>{I18n.l('common.loadingTable')}</span>
        </Page>
      );
    }

    return (
      <Page>
        <Wrapper>
          <Toolbar>
            <ToolbarItem>
              <RegisterBtnComponent
                onClick={this.toggleFormModal}
                buttonText={I18n.l('common.register') + " " + I18n.l('titles.targets')}
              />
            </ToolbarItem>
            <ToolbarItem>
              <SearchComponent
                onSubmit={this.searchTarget}
                placeholder='form.placeholders.formflowSearch'
                defaultValue={search}
                buttonText='form.buttons.search'
              />
            </ToolbarItem>
          </Toolbar>

          {tableData.length > 0 && (
            <React.Fragment>
              <div className={'goepik-component-tablesize'}>
                <Table
                  columns={tableColumns}
                  data={this.formatTargetDataToTable(tableData)}
                  onEdit={this.onEditTarget}
                  onDelete={this.deleteTarget}
                  noPagination={true}
                  showConfirmationModal={false}
                  onDownload={this.onDownload}
                  downloadLink={this.state.downloadLink}
                />
              </div>

              {offset && (
                <Button
                  className="loading-more"
                  type="primary"
                  size='large'
                  ghost
                  loading={loadingMoreFormflows}
                  onClick={() => this.loadMoreTargets()}>{I18n.l('common.seeMore')}</Button>
              )}
            </React.Fragment>


          )}

          {tableData.length === 0 && <p>{I18n.l('common.noResult')}</p>}

          <Modal
            visible={openTargetsRegister}
            footer={false}
            destroyOnClose={true}
            onCancel={this.toggleFormModal}
          >
            <ModalTitle>{I18n.l('common.register') + " " + I18n.l('titles.targets')}</ModalTitle>
            <React.Fragment >
              <Form hideRequiredMark={true}>
                <Form.Item
                  label={I18n.l('form.labels.name')}
                  colon={false}
                >
                  {getFieldDecorator('name', {
                    rules: [
                      { required: true, message: I18n.l('common.fieldRequired') },
                      {
                        min: 3, message: I18n.l('form.validation.text.min')
                      },
                    ],
                    initialValue: ''
                  })(
                    <Input />
                  )}
                </Form.Item>
                <Form.Item style={{ textAlign: 'right' }}>
                  <Button
                    style={{ marginRight: 8 }}
                    className="link primary bolder"
                    size="large"
                    onClick={this.toggleFormModal}>
                    {I18n.l('common.cancel')}
                  </Button>
                  <Button loading={this.state.loadingRequest ? true : false} type="primary" htmlType="submit" size="large" onClick={this.handleSubmit}>{I18n.l('common.save')}</Button>
                </Form.Item>
              </Form>
            </React.Fragment>

          </Modal>

          {/* EDIT MODAL*/}
          <Modal
            visible={openTargetsEdit}
            footer={false}
            destroyOnClose={true}
            onCancel={this.toggleFormModalEdit}
          >
            <ModalTitle>{I18n.l('common.register') + " " + I18n.l('titles.targets')}</ModalTitle>
            <React.Fragment >
              <Form hideRequiredMark={true}>
                <Form.Item
                  label={I18n.l('form.labels.name')}
                  colon={false}
                >
                  {getFieldDecorator('name', {
                    rules: [
                      { required: true, message: I18n.l('common.fieldRequired') },
                      {
                        min: 3, message: I18n.l('form.validation.text.min')
                      },
                    ],

                    initialValue: ""
                  })(
                    <Input />
                  )}
                </Form.Item>
                <img style={{ display: 'block', margin: '0 auto 1rem' }} src={this.state.editItem ? this.state.editItem.url : ''} alt="QRCode" width="50%" />
                <Form.Item style={{ textAlign: 'right' }}>
                  <Button
                    style={{ marginRight: 8 }}
                    className="link primary bolder"
                    size="large"
                    onClick={this.toggleFormModalEdit}>
                    {I18n.l('common.cancel')}
                  </Button>
                  <Button loading={this.state.loadingRequest ? true : false} type="primary" htmlType="submit" size="large" onClick={this.handleSubmit}>{I18n.l('common.save')}</Button>
                </Form.Item>
              </Form>
            </React.Fragment>

          </Modal>

          {showAuditsModal && (
            <SelectableDataComponent
              title={I18n.l('table.audits.linkProcess')}
              data={auditsData}
              showModal={showAuditsModal}
              loadingData={loadingAudits}
              auditorAuditsIds={auditsAlreadySaved}
              onItemRemoved={this.onRemoveAudit}
              onItemSelected={this.onAddProcess}
              serverResponse={serverResponse}
              onToggleFormModal={() => this.toggleProcessModal()}
              hasMoreProcessesToSave={curProcessesOffset != undefined && curProcessesOffset !== ''}
              onSeeMorePressed={this.onSeeMoreProcesses}
              loadingSeeMore={loadingMoreProcesses}
            />
          )}

        </Wrapper>
      </Page >
    );
  }
}


const Wrapper = styled.div`
    display: flex;
    flex-flow: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
`;

const Image = styled.div`
display: block;
margin: 0 auto;
`

const Toolbar = styled.div`
    flex: 0;
    display: flex;
    flex-flow: row nowrap;
    margin-bottom: 40px;
    width: 100%;
`;

const ToolbarItem = styled.div`
    flex: 1;
    margin-left: 50px;
    
    &:first-of-type {
        flex: 0;
        margin-left: 0;
    }
`;

const ModalTitle = styled.h3`
  font-size: 22px;
`;

const ModalContent = styled.div`
  width: 100%;
`;

export const TargetsContainer = Form.create()(TargetsClass);